<template>
  <NuxtLink
    :to="{ name: 'index' }"
    class="focus-visible:focus inline-block rounded md:py-2.5"
  >
    <YscLogo class="h-5 w-auto md:h-8" />
  </NuxtLink>
</template>
